function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as m } from "./index.es33.js";
import { useState as u, useRef as z, useEffect as b } from "react";
import { clsx as D } from "./index.es105.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as N } from "./index.es36.js";
import { Icon as y } from "./index.es7.js";
import { ResizeDirection as e } from "./index.es48.js";
import R from "./index.es206.js";
var C = function C(_ref) {
  var w = _ref.children,
    l = _ref.minHeight,
    a = _ref.minWidth,
    p = _ref.maxHeight,
    d = _ref.maxWidth,
    E = _ref.width,
    i = _ref.height,
    _ref$resizeDirection = _ref.resizeDirection,
    c = _ref$resizeDirection === void 0 ? e.none : _ref$resizeDirection,
    j = _ref.className;
  var _u = u(null),
    _u2 = _slicedToArray(_u, 2),
    t = _u2[0],
    f = _u2[1],
    _u3 = u(E),
    _u4 = _slicedToArray(_u3, 2),
    H = _u4[0],
    g = _u4[1],
    _u5 = u(i),
    _u6 = _slicedToArray(_u5, 2),
    h = _u6[0],
    M = _u6[1],
    s = z(null);
  b(function () {
    i !== h && M(i);
  }, [i]);
  var v = function v(o) {
      if (t && [e.row, e.all].includes(c)) {
        var n = o.clientX - t.x + t.w,
          r = Math.max(n, a || n);
        g(Math.min(r, d || r));
      }
      if (t && [e.column, e.all].includes(c)) {
        var _n = o.clientY - t.y + t.h,
          _r = Math.max(_n, l || _n);
        M(Math.min(_r, p || _r));
      }
    },
    x = function x() {
      return f(null);
    },
    L = function L(o) {
      return s.current && f({
        x: o.clientX,
        y: o.clientY,
        h: s.current.clientHeight,
        w: s.current.clientWidth
      });
    };
  return b(function () {
    return t && (document.addEventListener("mousemove", v), document.addEventListener("mouseup", x)), function () {
      document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", x);
    };
  }, [t]), m.jsxs("div", {
    ref: s,
    className: D(R.container, j),
    style: {
      width: H,
      height: h,
      minWidth: a,
      minHeight: l,
      maxWidth: d,
      maxHeight: p
    },
    children: [w, c !== e.none && m.jsx("button", {
      onMouseDown: L,
      className: R.button,
      type: "button",
      children: m.jsx(y, {
        icon: y.icons.outline.resize,
        color: N.gray6,
        className: "icon",
        size: 6
      })
    })]
  });
};
C.ResizeDirection = e;
export { C as Resizeable };